import Vue from 'vue';
import Router from 'vue-router';
import { isLogged, onLogin } from '@/vue-apollo.js';
import { apollo } from '@/store';

import BaseLayout from '@/components/layout/BaseLayout';

import Welcome from '@/components/layout/Welcome';
import ProjectView from "@/pages/poll/ProjectView";

import PollConfig from "@/pages/poll/PollCreateEdit"
import PollManage from "@/pages/poll/PollManage"

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'Welcome',
    component: Welcome,
    meta: { requiresAuth: false },
  },
  {
    path: '/:domain/project-view/:id',
    name: 'ProjectViewDomain',
    component: ProjectView,
    meta: { requiresAuth: false },
  },
  {
    path: '/project-view/:id',
    name: 'ProjectView',
    component: ProjectView,
    meta: { requiresAuth: false },
  },
  {
    path: '',
    component: BaseLayout,
    props: true,
    meta: { requiresAuth: true },
    children: [{
      path: '/poll/new',
      name: 'PollNew',
      props: true,
      component: PollConfig,
    }, {
      path: '/poll/:id/edit',
      name: 'PollEdit',
      props: true,
      component: PollConfig
    }, {
      path: '/poll/:id',
      name: 'PollManage',
      props: true,
      component: PollManage
    }]
  },
  {
    path: '/:domain',
    name: 'WelcomeDomain',
    component: Welcome,
    meta: { requiresAuth: false },
  },
]

const router = new Router({
  routes,
  mode: 'history',
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    const hasLogged = await isLogged();
    const noHasParamToken = !to.query && !to.query.token;
    const notLogged = !hasLogged && noHasParamToken;
    if (notLogged) {
      window.location = 'https://prosas.com.br/users/sign_in';
    } else {
      const token = to.query.token;
      onLogin(apollo, token);
      await apollo.defaultClient.query({
        query: require('../graphql/checkLogin.gql')
      });
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js